export default __webpack_public_path__ + "static/media/culture_EP8.41c0bddc.png";